/* DON-631 Feliratkozás:
   - .js-writer-subscribe-btn  → belépett user, e-mail nélkül (a szerver a session
     userrel iratkoztat) — modal ingyenes kártya + inline doboz readonly változata.
   - .js-writer-subscribe-form → e-mail formos feliratkozás (anonim: szerkeszthető
     mező + honeypot/fts botszűrés; belépett: readonly mező, a szerver a session
     usert használja). Modal ingyenes kártya + cikk/lista/egyhasábos inline dobozok.
   Siker után a szerver anonim esetben követő-cookie-t állít (wfol{channel_id}),
   így újratöltéskor már szerveroldalon is „feliratkozott" az állapot. */

(function () {

    function applyFollowerUI() {
        if (!window.WP) return;
        WP.body.dataset.alreadyFollower = '1';
        var navText = document.querySelector('.pw__nav-button .text');
        if (navText) { navText.textContent = WP.L.TAMOGATOM; }

        WP.closeActiveModals();
        setTimeout(function () {
            // A modal ingyenes feliratkozás-kártyája már nem kell (a twig sem rendereli
            // már-követőnek), ezért ez marad törlés.
            document.querySelectorAll('.fanpage__box-free').forEach(function (b) {
                b.remove();
            });
            // Az oldalon lévő feliratkozó dobozok viszont ne tűnjenek el: a
            // box_subscription.html.twig mindkét állapotot kirendereli, itt csak
            // átkapcsolunk a „Legyél támogató!" változatra — ugyanaz, mintha az
            // `already_follower` ág futott volna le szerveroldalon.
            document.querySelectorAll('.js-subscription-box').forEach(function (b) {
                b.style.display = (b.dataset.subState === 'follower') ? '' : 'none';
            });
            // A footer feliratkozás formját már-követőnek a twig sem rendereli —
            // AJAX feliratkozás után itt rejtjük el (nincs támogatói változata).
            document.querySelectorAll('.js-footer-subscription').forEach(function (b) {
                b.style.display = 'none';
            });
            WP.triggerModal('successSubscriptionModal');
        }, 50);
    }

    function postSubscribe(fd, unlock) {
        fetch(WP.BASE + '/ajax_writerpublic_subscribe', {
            method: 'POST',
            body: fd,
            credentials: 'same-origin'
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
            unlock();
            if (data.success) {
                applyFollowerUI();
            } else {
                alert(data.message || WP.L.ERR_NETWORK);
                // Lejárt (>24h nyitva hagyott oldal) vagy túl friss fts token: újratöltés
                // nélkül a retry sosem sikerülne — friss tokent csak új renderből kap.
                if (data.error === 'bot_check') {
                    window.location.reload();
                }
            }
        })
        .catch(function () {
            unlock();
            alert(WP.L.ERR_NETWORK);
        });
    }

    // Belépett user — gombos (e-mail nélküli) feliratkozás.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.js-writer-subscribe-btn') : null;
        if (!btn || !window.WP) return;
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;

        var fd = new FormData();
        fd.append('channelurl', btn.dataset.channelurl || WP.body.dataset.channelurl || '');
        postSubscribe(fd, function () { btn.disabled = false; });
    });

    // E-mail formos feliratkozás (modal ingyenes kártya + inline dobozok).
    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form.classList || !form.classList.contains('js-writer-subscribe-form') || !window.WP) return;
        e.preventDefault();

        var emailEl = form.querySelector('input[name="email"]');
        var submit  = form.querySelector('button[type="submit"]');
        var email   = emailEl ? emailEl.value.trim() : '';
        var group   = emailEl ? emailEl.closest('.old-form-group') : null;

        if (group) { group.classList.remove('has-error'); }
        if (!email || email.indexOf('@') < 1) {
            if (group) { group.classList.add('has-error'); }
            if (emailEl) { emailEl.focus(); }
            return;
        }
        if (submit && submit.disabled) return;
        if (submit) { submit.disabled = true; }

        var fd = new FormData();
        fd.append('channelurl', form.dataset.channelurl || WP.body.dataset.channelurl || '');
        fd.append('email', email);
        var hp = form.querySelector('input[name="website"]');
        fd.append('website', hp ? hp.value : '');
        var fts = form.querySelector('input[name="fts"]');
        fd.append('fts', fts ? fts.value : '');

        postSubscribe(fd, function () { if (submit) { submit.disabled = false; } });
    });

})();
